import { FormControl, FormLabel, FormGroup, FormControlLabel, Checkbox } from '@mui/material';
import { useCallback } from 'react';

const CheckBoxClear = (props) => {

    const {
        label,
        options,
        arrSelect,
        setArrSelect,
        onChange,
        isSelectAll = true
    } = props;

    const handleSelectAllClick = (event: React.ChangeEvent<HTMLInputElement>) => {
        if (event.target.checked) {
            const newSelected = options.filter(f=>f.disabled !== true).map((n) => n.value);
            setArrSelect(newSelected);
            if(onChange){
                onChange(newSelected)
            }
            return;
        }
        setArrSelect([]);

        if(onChange){
            onChange([])
        }
    };

    const handleClick = (idValue) => {
        const selectedIndex = arrSelect.indexOf(idValue);
        let newSelected = [];

        if (selectedIndex === -1) {
            newSelected = newSelected.concat(arrSelect, idValue);
        } else if (selectedIndex === 0) {
            newSelected = newSelected.concat(arrSelect.slice(1));
        } else if (selectedIndex === arrSelect.length - 1) {
            newSelected = newSelected.concat(arrSelect.slice(0, -1));
        } else if (selectedIndex > 0) {
            newSelected = newSelected.concat(
                arrSelect.slice(0, selectedIndex),
                arrSelect.slice(selectedIndex + 1),
            );
        }
        setArrSelect(newSelected);
        if(onChange){
            onChange(newSelected)
        }
    };

    const isSelected = (id: number) => arrSelect.indexOf(id) !== -1;

    return (
        <FormControl component="fieldset" variant="standard">
            <FormLabel component="legend">{label}</FormLabel>
            <FormGroup row={false}>
                {isSelectAll && <FormControlLabel
                    control={
                        <Checkbox
                            size='small'
                            checked={options.length > 0 && arrSelect.length === options.length}
                            onChange={handleSelectAllClick}
                        />
                    }
                    label={`เลือกทั้งหมด`}
                />}
                {options.map(item => {
                    const isItemSelected = isSelected(item.value);
                    return (
                        <FormControlLabel
                            key={`valuecheck-${item.label}`}
                            disabled={item.disabled}
                            control={
                                <Checkbox
                                    name={`name-${item.label}`}
                                    checked={isItemSelected}
                                    size='small'
                                    onClick={() => handleClick(item.value)}
                                />
                            }
                            label={item.label}
                        />
                    )

                })
                }
            </FormGroup>
        </FormControl>
    )
}

export default CheckBoxClear